import * as React from "react";
import QueryHelper from "components/common/QueryHelper";
const queryExample = /* @__PURE__ */ React.createElement("p", null, "Find failed report runs:", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "status:FAILURE"), /* @__PURE__ */ React.createElement("br", null));
const fieldMap = {
  status: "The status of the report job"
};
const ReportQueryHelper = () => /* @__PURE__ */ React.createElement(QueryHelper, { example: queryExample, entityName: "report archive", commonFields: [], fieldMap });
export default ReportQueryHelper;
